import { Injectable } from '@angular/core';
import { RestApiService } from '../../services/rest-api.service';
import { Observable } from 'rxjs';
import { AppSettings } from '../../app.settings';

@Injectable()
export class Grid2Service {
  constructor(private restApiService: RestApiService) { }

  public loadGridData(url: string, method: string = AppSettings.METHOD_TYPE.GET, body?: any): Observable<{}> {
    if (method === AppSettings.METHOD_TYPE.POST) {
      return this.restApiService.post(url, body || {}, 'page-center');
    }
    return this.restApiService.get(url, 'page-center');
  }

  public downloadExcelGridData(url: string) {
    return this.restApiService.excel(url, 'export.xls', 'page-center');
  }

  public downloadExcelGridDataPost(url: string, body: any) {
    return this.restApiService.excelPost(url, body, 'export.xls', 'page-center');
  }

  public downloadPdfGridData(url: string) {
    return this.restApiService.pdf(url, 'print.pdf', 'page-center');
  }

  public downloadPdfGridDataPost(url: string, body: any) {
    return this.restApiService.pdfPost(url, body, 'print.pdf', 'page-center');
  }
}
